import { OrderSet } from "@models/OrderSet";

import {
  ALL_REGIONS_ORDERING_CTX_ID,
  DistributorOrderingCtx,
  OrderingCtxType,
  SWEEPSTAKE_ORDERING_CTX_ID,
  getOrderingCtxId,
} from "./OrderingCtx";

export const getOrderingCtxIdForOrderSet = (orderSet: OrderSet) => {
  if (orderSet.market) {
    return getOrderingCtxId(OrderingCtxType.Market, orderSet.market.id);
  }
  if (orderSet.territory) {
    return getOrderingCtxId(OrderingCtxType.Territory, orderSet.territory.id);
  }
  if (orderSet.allRegions) {
    if (orderSet.isCouponSweepstakes) {
      return SWEEPSTAKE_ORDERING_CTX_ID;
    }
    return ALL_REGIONS_ORDERING_CTX_ID;
  }

  return null;
};

export const getOrderSetAttributesFromCtx = (
  orderingCtx: DistributorOrderingCtx,
  channel?: string | undefined,
  programId?: string | undefined
) => {
  if (orderingCtx.id === SWEEPSTAKE_ORDERING_CTX_ID) {
    return {
      isForDistributor: false,
      isCouponSweepstakes: true,
      channel,
      allRegions: true,
      programId,
    };
  }
  if (orderingCtx.id === ALL_REGIONS_ORDERING_CTX_ID) {
    return {
      isForDistributor: true,
      allRegions: true,
    };
  }
  return {
    isForDistributor: true,
    marketId: orderingCtx.marketId,
    territoryId: orderingCtx.territoryId,
  };
};
